function getTimezoneOffset() {
    Date.prototype.stdTimezoneOffset = function () {
        var jan = new Date(this.getFullYear(), 0, 1);
        var jul = new Date(this.getFullYear(), 6, 1);
        return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    }

    Date.prototype.isDstObserved = function () {
        return this.getTimezoneOffset() < this.stdTimezoneOffset();
    }

    var today = new Date();
    // assumes Eastern time zone
    if (today.isDstObserved()) {
        return '-04:00';
    }
    return '-05:00';
}
function formatDateValue(value) {
    if (!value) {
        return '00';
    }
    if (value < 10) {
        value = 0 + value;
    }
    return value;
}
const countdownBar = document.querySelector('.countdown-bar');
if (countdownBar) {
    const dateString = `${countdownBar.dataset.year}-${formatDateValue(countdownBar.dataset.month)}-${formatDateValue(countdownBar.dataset.day)}T${formatDateValue(countdownBar.dataset.hour)}:${formatDateValue(countdownBar.dataset.minute)}:00${getTimezoneOffset()}`;
    const endTime = new Date(dateString).getTime();

    let x = setInterval(function () {
        let now = new Date().getTime();
        let distance = endTime - now;
        if (distance < 0) {
            clearInterval(x);
            return;
        }
        document.getElementById("days-left").innerHTML = Math.floor(distance / (1000 * 60 * 60 * 24));
        document.getElementById("hours-left").innerHTML = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        document.getElementById("minutes-left").innerHTML = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        document.getElementById("seconds-left").innerHTML = Math.floor((distance % (1000 * 60)) / 1000);
    }, 1000);
}
